<template>
  <div class="dash-footer">
    <div class="container text-center">
      <p>&copy; {{ footerYear }} Safari-Tz</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",

  data() {
    return {
      footerYear: null,
    };
  },

  mounted() {
    this.footerYear = new Date().getFullYear();
  },
};
</script>
